import { FlatList, Text, View } from "react-native";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { MedicationItem } from "../organisms/MedicationItem";
import { useMedicationHistoryWithOffline } from "app/features/offline/hooks/useMedicationHistoryWithOffline";
import { MedicationListFrequencyFilter } from "../molecules/MedicationListFrequencyFilter";

export function MedicationHistoryTemplate() {
  const { data, isFetching, frequencies, handleFrequencyChange } = useMedicationHistoryWithOffline();

  return (
    <View className="flex-1">
      <FlatList
        contentContainerClassName="gap-3.5"
        data={data ?? []}
        keyExtractor={(item) => `${item.id}`}
        ListHeaderComponent={<MedicationListFrequencyFilter filters={frequencies} onChangeFilters={handleFrequencyChange} />}
        renderItem={({ item }) => (
          <MedicationItem medication={item} isDiscontinued />
        )}
        ListEmptyComponent={
          !isFetching ? (
            <Text className="text-center">
              This resident has no previous medications
            </Text>
          ) : (
            <LoadingSpinner />
          )
        }
      />
    </View>
  );
}
